import { useContext } from 'react';

import { TrackingContext } from '@/providers/TrackingProvider';

const useTrackingProvider = () => {
    const ctx = useContext(TrackingContext);

    return {
        ...ctx,
    };
};

export default useTrackingProvider;
